import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.1_@biomejs+biome@1.9.4_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node_f38705549ce991e98cc82880522c865b/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}